import type { FC } from "react";
import type { TranslationKey } from "src/types/translationKey";
import LoaderIconImage from "src/ui/components/BlockingLoadingOverlay/LoadingIconSmall.webp";
import Translate from "src/ui/components/Translate/Translate";
import { OverlayPillWithSpinnerStyled } from "./OverlayPillWithSpinner.styled";

const { Pill, Content, LoaderWrap, Spinner, TextBlock, Text, TrailingSpacer } =
  OverlayPillWithSpinnerStyled;

interface OverlayPillWithSpinnerProps {
  msg: TranslationKey;
  /** Lets a parent position the pill (e.g. absolutely over a media frame). */
  className?: string;
}

const OverlayPillWithSpinner: FC<OverlayPillWithSpinnerProps> = ({
  msg,
  className
}) => {
  return (
    <Pill className={className} role="status" aria-live="polite">
      <Content>
        <LoaderWrap aria-hidden="true">
          <Spinner src={LoaderIconImage} alt="" />
        </LoaderWrap>
        <TextBlock>
          <Text>
            <Translate msg={msg} />
          </Text>
        </TextBlock>
        <TrailingSpacer aria-hidden="true" />
      </Content>
    </Pill>
  );
};

export default OverlayPillWithSpinner;
